import {FavoriteStore} from "../init";


const favoriteCreateLocal = async (data) => FavoriteStore.add({ ...data});
export default favoriteCreateLocal;